<template>
  <div class="news-detail-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <router-link to="/news">新闻资讯</router-link> &gt;
        <span>新闻详情</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <article class="detail-card card-modern">
        <header class="detail-header">
          <h1 class="title">{{ newsData.title }}</h1>
          <div class="meta-info">
            <span
              ><i class="el-icon-user"></i> 来源：{{
                newsData.author || ""
              }}</span
            >
            <span
              ><i class="el-icon-time"></i> 发布时间：{{
                newsData.publishDate
              }}</span
            >
            <span
              ><i class="el-icon-view"></i> 浏览次数：{{ newsData.click }}</span
            >
          </div>
        </header>

        <div
          class="detail-body rich-text-content"
          v-html="newsData.content"
        ></div>
      </article>
    </main>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import article from "@/api/article";

export default {
  name: "NewsDetail",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("@/assets/images/banner1.png"),
      defaultImage:
        "https://minio.gxbcxx.com/baochenhome/upload/20260306/49f3a6feae87249631b8ba0bdbe312f2.jpg",
      newsData: {},
    };
  },
  updated() {
    this.handleRichTextImageError();
  },
  created() {
    if (this.$route.query) {
      let id = this.$route.query.id;
      this.getList(id);
    }
  },
  methods: {
    handleRichTextImageError() {
      this.$nextTick(() => {
        const imgs = this.$el.querySelectorAll(".rich-text-content img");
        imgs.forEach((img) => {
          if (!img.getAttribute("data-error-handled")) {
            img.onerror = () => {
              img.src = this.defaultImage;
              img.onerror = null;
            };
            img.setAttribute("data-error-handled", "true");
            // 检查图片是否已经加载失败（针对缓存或极快加载的情况）
            if (img.complete && img.naturalWidth === 0) {
              img.src = this.defaultImage;
            }
          }
        });
      });
    },
    getList(id) {
      article
        .getDetail({ id: id })
        .then((res) => {
          this.newsData = res.data.data;
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.news-detail-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.detail-card {
  background: #ffffff;
  padding: 60px 80px;
  border-radius: @border-radius;
}

.detail-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid @border-color;

  .title {
    font-size: 28px;
    font-weight: 700;
    color: @text-main;
    margin-bottom: 24px;
    line-height: 1.4;
  }

  .meta-info {
    font-size: 14px;
    color: @text-muted;
    display: flex;
    justify-content: center;
    gap: 32px;
    i {
      margin-right: 6px;
    }
  }
}

.detail-body {
  font-size: 16px;
  line-height: 1.8;
  color: @text-secondary;
  min-height: 400px;

  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 4px;
    margin: 24px 0;
  }

  /deep/ p {
    margin-bottom: 16px;
  }
}

.detail-footer {
  margin-top: 60px;
  padding-top: 32px;
  border-top: 1px solid @border-color;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .detail-card {
    padding: 32px 20px;
  }
  .detail-header .title {
    font-size: 22px;
  }
  .meta-info {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
